import { createAsyncThunk } from '@reduxjs/toolkit';
import { ManagementApi } from '../http';
import { IManagement } from '../models';

const managementApi = new ManagementApi();

export const fetchManagementUpdate = createAsyncThunk(
  'management/update',
  async (body: IManagement, { rejectWithValue }) => {
    try {
      return await managementApi.updateOne(body);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
